<div id="message" class="py-4 mx-md-5">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h2 class="home-title text-center mb-2">Words from Our Leaders</h2>
            </div>
        </div>

        <owl-carousel-o [options]="customOptions">
            <ng-container>

                <!-- Chairperson Slide -->
                <ng-template carouselSlide>
                    <div class="row">
                        <div class="col-12">
                            <div class="message-card">
                                <div class="row g-0">
                                    <!-- Left Column: Image with Overlay -->
                                    <div class="col-12 col-md-5 message-image-wrapper">
                                        <img src="/assets/img/message/chairperson.jpg" class="message-image"
                                            alt="Chairperson Message"
                                            onerror="this.src='https://placehold.co/400x500?text=Chairperson'">
                                        <div class="image-overlay">
                                            <h3 class="overlay-name">Mrs. Sudha Aggarwal</h3>
                                            <p class="overlay-title">Chairperson, IIMT</p>
                                        </div>
                                    </div>

                                    <!-- Right Column: Message Content -->
                                    <div class="col-12 col-md-7 message-content-wrapper">
                                        <div class="message-content">
                                            <div class="quote-icon">
                                                <i class="fas fa-quote-right"></i>
                                            </div>
                                            <h2 class="message-heading">Chairperson's Message</h2>
                                            <div class="message-text">
                                                <p class="message-quote">"Education’s purpose is to replace an empty
                                                    mind with an open one."</p>
                                                <p class="message-description">IIMT is a forward-thinking institute, our
                                                    endeavour is to nurture holistic world
                                                    citizens, who are driven by human values and equipped to excel on a
                                                    global stage. Furthering the aim
                                                    to carry forward the legacy of the rich educational and intellectual
                                                    heritage of our soil our great
                                                    visionary and founder Late Sh. Rakesh Aggarwal Ji, established the
                                                    institute in 1999.
                                                </p>
                                            </div>
                                            <button class="read-more-btn" routerLink="/about/messages">
                                                Read Full Message
                                                <i class="fas fa-arrow-right ms-2"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>

                <!-- Vice-Chairperson Slide -->
                <ng-template carouselSlide>
                    <div class="row">
                        <div class="col-12">
                            <div class="message-card">
                                <div class="row g-0">
                                    <!-- Left Column: Image with Overlay -->
                                    <div class="col-12 col-md-5 message-image-wrapper">
                                        <img src="/assets/img/message/v-chairpersson.jpg" class="message-image"
                                            alt="Vice-Chairperson Message"
                                            onerror="this.src='https://placehold.co/400x500?text=Vice-Chairperson'">
                                        <div class="image-overlay">
                                            <h3 class="overlay-name">Mrs. Neetu Aggarwal</h3>
                                            <p class="overlay-title">Vice-Chairperson, IIMT</p>
                                        </div>
                                    </div>

                                    <!-- Right Column: Message Content -->
                                    <div class="col-12 col-md-7 message-content-wrapper">
                                        <div class="message-content">
                                            <div class="quote-icon">
                                                <i class="fas fa-quote-right"></i>
                                            </div>
                                            <h2 class="message-heading">Vice-Chairperson's Message</h2>
                                            <div class="message-text">
                                                <p class="message-quote">"In this era of highly competitive global
                                                    market, there should be a synergy between today’s need & tomorrow’s
                                                    expectation."</p>
                                                <p class="message-description">At IIMT we believe in bridging this gap
                                                    through futuristic learning and
                                                    skill development of both our students and faculties. You are
                                                    joining us at a time when higher education
                                                    in our country is undergoing rapid and dramatic transformation.
                                                    Thus, shall imbibe the vision of the
                                                    latest changes in the educational policies in the scheme of
                                                    learning. We live in an era when knowledge
                                                    is growing in importance in addressing the world’s most pressing
                                                    problems. We at IIMT aspire to empower
                                                    all young minds to succeed in their world by offering a wide variety
                                                    of challenging, enjoyable and
                                                    successful curricular, co-curricular and extra-curricular
                                                    opportunities. I wish you all the best for
                                                    your knowledgeable journey !!
                                                </p>
                                            </div>
                                            <button class="read-more-btn" routerLink="/about/messages">
                                                Read Full Message
                                                <i class="fas fa-arrow-right ms-2"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>

                <!-- Secretary General Slide -->
                <ng-template carouselSlide>
                    <div class="row">
                        <div class="col-12">
                            <div class="message-card">
                                <div class="row g-0">
                                    <!-- Left Column: Image with Overlay -->
                                    <div class="col-12 col-md-5 message-image-wrapper">
                                        <img src="/assets/img/message/secretary.jpg" class="message-image"
                                            alt="Secretary General Message"
                                            onerror="this.src='https://placehold.co/400x500?text=Secretary+General'">
                                        <div class="image-overlay">
                                            <h3 class="overlay-name">Shri Vineet Aggarwal</h3>
                                            <p class="overlay-title">Secretary General, IIMT</p>
                                        </div>
                                    </div>

                                    <!-- Right Column: Message Content -->
                                    <div class="col-12 col-md-7 message-content-wrapper">
                                        <div class="message-content">
                                            <div class="quote-icon">
                                                <i class="fas fa-quote-right"></i>
                                            </div>
                                            <h2 class="message-heading">Secretary General Message</h2>
                                            <div class="message-text">
                                                <p class="message-quote">"Our education system is a mirror that reflects
                                                    our society."</p>
                                                <p class="message-description">It is an agent of social change
                                                    and should aim at drawing out the best in our students and make them
                                                    conscious about their rights,
                                                    duties and obligations as responsible citizens of our great nation.
                                                    We continue our enthusiastic pursuit
                                                    towards excellence at IIMT by refining and redefining learning
                                                    through innovative, future-forward,
                                                    technologically sound teaching pedagogy that prepares students for
                                                    leadership positions and the
                                                    challenges of the 21st century. The principles of modesty,
                                                    compassion coupled with innovative ideas to
                                                    effectuate novelty, growth and excellence is the Holy Grail of IIMT
                                                    embedded by our illustrious
                                                    Visionary Late Sh. Rakesh Aggarwal Ji. I pledge to extend this
                                                    vision to its fullest aspect through
                                                    quality learning, adequately equipping the learners with intellect
                                                    and integrity to stride into the
                                                    competitive global market with confidence and courage.
                                                </p>
                                            </div>
                                            <button class="read-more-btn" routerLink="/about/messages">
                                                Read Full Message
                                                <i class="fas fa-arrow-right ms-2"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>

                <!-- Director Slide -->
                <ng-template carouselSlide>
                    <div class="row">
                        <div class="col-12">
                            <div class="message-card">
                                <div class="row g-0">
                                    <!-- Left Column: Image with Overlay -->
                                    <div class="col-12 col-md-5 message-image-wrapper">
                                        <img src="/assets/img/message/Director.jpg" class="message-image"
                                            alt="Director Message"
                                            onerror="this.src='https://placehold.co/400x500?text=Director'">
                                        <div class="image-overlay">
                                            <h3 class="overlay-name">Prof. (Dr.) Anil Parkash Sharma</h3>
                                            <p class="overlay-title">Director, IIMT</p>
                                        </div>
                                    </div>

                                    <!-- Right Column: Message Content -->
                                    <div class="col-12 col-md-7 message-content-wrapper">
                                        <div class="message-content">
                                            <div class="quote-icon">
                                                <i class="fas fa-quote-right"></i>
                                            </div>
                                            <h2 class="message-heading">Director's Message</h2>
                                            <div class="message-text">
                                                <p class="message-quote">"The essence of true education is not only to
                                                    facilitate the students with tools to attain success but also to
                                                    engrain values in them."</p>
                                                <p class="message-description">Extending the vision of the extraordinary
                                                    stalwart Late Sh. Rakesh Aggarwal Ji, We have
                                                    assured that learning and growth at IIMT are not confined to mere
                                                    classroom and academic experiences.
                                                    We feel pride to indulge our Students in rich and varied
                                                    extracurricular and co- curricular activities
                                                    for their holistic learning development and become global leaders.
                                                    At IIMT, the learners undergo a
                                                    creative transformation and shall remold you to achieve excellence
                                                    by encouraging you to think beyond
                                                    the ordinary and attain greatness. Your learning at IIMT shall
                                                    become prized mantras for you and help
                                                    you inculcate the power of anticipation and visualization coupled
                                                    with the rigor, resilience and agility
                                                    to realize them.
                                                </p>
                                            </div>
                                            <button class="read-more-btn" routerLink="/about/messages">
                                                Read Full Message
                                                <i class="fas fa-arrow-right ms-2"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-template>

            </ng-container>
        </owl-carousel-o>

    </div>
</div>